import { useState } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Categories } from "@/components/landing/Categories";
import { Deliverables } from "@/components/landing/Deliverables";
import { StayTour } from "@/components/landing/StayTour";
import { Packages } from "@/components/landing/Packages";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { RegistrationDialog, QrDialog, PaymentProofDialog } from "@/components/landing/RegistrationForm";

export default function LandingPage() {
  const [regOpen, setRegOpen] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const [proofOpen, setProofOpen] = useState(false);

  return (
    <div className="bg-[#09090B] min-h-screen">
      <Navbar onRegister={() => setRegOpen(true)} />
      <Hero onRegister={() => setRegOpen(true)} onQr={() => setQrOpen(true)} />
      <Categories />
      <Deliverables />
      <StayTour />
      <Packages onRegister={() => setRegOpen(true)} onProof={() => setProofOpen(true)} />
      <Contact />
      <Footer />
      <RegistrationDialog open={regOpen} onOpenChange={setRegOpen} />
      <QrDialog open={qrOpen} onOpenChange={setQrOpen} />
      <PaymentProofDialog open={proofOpen} onOpenChange={setProofOpen} />
    </div>
  );
}
